'use client';

import { useEffect } from 'react';
import { reportError } from '@core/lib/errorReporter';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    reportError(error, { digest: error.digest, source: 'global-error' });
  }, [error]);

  return (
    <html>
      <body>
        <h1>Something went wrong</h1>
        <p>An unexpected error occurred. Please try again later.</p>
      </body>
    </html>
  );
}
